import {CommonModule} from '@angular/common';
import {Component, inject, NgModule} from '@angular/core';
import {MatDividerModule} from '@angular/material/divider';
import {MatMenuModule} from '@angular/material/menu';
import {ProductsCountriesService} from '@em/data-feed/data-access-products';
import {EmButtonModule, EmCountryFlagModule, EmIconModule} from '@em/shared/ui';
import {OrderByTranslatedPipe} from '@em/shared/util-i18n';
import {CountryCode} from '@em/shared/util-types';
import {CountryService} from '@em/user-account/data-access';
import {TranslateModule} from '@ngx-translate/core';
import {combineLatest, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'em-country-selection',
  templateUrl: './country-selection.component.html',
  styleUrls: ['./country-selection.component.scss'],
  standalone: false,
})
export class CountrySelectionComponent {
  private readonly _country = inject(CountryService);
  private readonly _productCountiesService = inject(ProductsCountriesService);

  countries: Observable<CountryCode[]>;
  currentCountry: Observable<CountryCode>;

  constructor() {
    this.currentCountry = this._country.observable();
    this.countries = combineLatest([
      this._country.observable(),
      this._productCountiesService.availableCountries$,
    ]).pipe(
      map(([currentCountry, availableCountries]) =>
        availableCountries.filter((c) => currentCountry !== c),
      ),
    );
  }

  select(countryCode: CountryCode | string): void {
    this._country.change(countryCode as CountryCode);
  }

  i18nKey(countryCode: CountryCode | string): string {
    return `COUNTRY_${countryCode}`;
  }
}

@NgModule({
  declarations: [CountrySelectionComponent],
  exports: [CountrySelectionComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatDividerModule,
    EmCountryFlagModule,
    TranslateModule,
    EmButtonModule,
    EmIconModule,
    OrderByTranslatedPipe,
  ],
})
export class CountrySelectionModule {}
